import SearchBox from "../components/SearchBox";
import backgroundMobile from "../assets/images/homepage-banner-mobile.jpg?v=2";
import backgroundDesktop from "../assets/images/homepage-banner-desktop.jpg?v=2";
import { T } from "@tolgee/react";
import useAppState from "../store/appState";

function HomePage() {
  const { isMobile } = useAppState();

  return (
    <section className="bg-white">
      <div className="relative">
        <img className=" w-full" src={isMobile ? backgroundMobile : backgroundDesktop} alt="Background"></img>
        <div className="w-full px-4 lg:px-0 mx-auto mt-[27px] lg:absolute text-black lg:text-grey-1-sp font-roboto md:items-center flex flex-col lg:translate-x-[-50%] lg:translate-y-[-50%] lg:top-[44%] lg:left-1/2">
          <p className="leading-[48px] lg:leading-[70px] text-[42px] lg:text-[64px] font-semibold lg:drop-shadow-lg">
            {isMobile ? <T keyName="HomePage.h1.title.mobile" /> : <T keyName="HomePage.h1.title.desktop" />}
          </p>
          <h2 className="leading-[24px] mt-[17px]  lg:mb-[28px] lg:mt-[11px] text-[18px] lg:text-[24px] font-medium lg:drop-shadow-lg ">
            <T keyName="HomePage.h2.subtitle" />
          </h2>
          <div className="mt-[33px] mb-[128px] lg:mb-[0px] lg:mt-[0px]  flex">
            <SearchBox />
          </div>
        </div>
      </div>
    </section>
  );
}

export default HomePage;
